// extracted by mini-css-extract-plugin
export default {"snack":"CookieAlert_snack__7PEgg","container":"CookieAlert_container__ZPocx","button":"CookieAlert_button__6zKSi"};